<div class="MainContainer">
    <div class="MainBody">
      <div class="NewCompanyContainer">

        <div class="MainTitleBarNewCompany">
            {{ 'AddNewCompany' | translate }}
        </div>

        <div class="MainTitleBarNewCompany">
          {{ 'CompanyData' | translate }}
        </div>

          <mat-form-field appearance="outline" class="example-full-width NewCompanyTextField">
              <mat-label>{{ 'Partners.PartnerWindow.ChooseCountry' | translate }}</mat-label>
              <mat-select name="country" [compareWith]="compareFn" [(ngModel)]="Country" required [disabled]="!ShowStepOne">
                <mat-option *ngFor="let c of parent.masterData.Countries" [value]="c" (click)="TestCompanyValidity();">
                  {{c.Name}}
                </mat-option>
              </mat-select>
            </mat-form-field>

        <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
            <mat-label>{{ 'Partners.VAT' | translate }}</mat-label>
            <input matInput [(ngModel)]="this.Company.VATNumber" (ngModelChange)="TestCompanyValidity();" [disabled]="!ShowStepOne">
            <i class="material-icons CheckEUVATButton" *ngIf="this.Company.VATNumber?.length && this.Country != null && ShowStepOne;" (click)="GetPartnerEUData();">cloud_download</i>
          </mat-form-field>

          <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
            <mat-label>{{ 'Partners.Name' | translate }}</mat-label>
            <input matInput [(ngModel)]="this.Company.Name" (ngModelChange)="TestCompanyValidity();" [disabled]="!ShowStepOne">
          </mat-form-field>

          <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
            <mat-label>{{ 'Partners.COCRegNumber' | translate }}</mat-label>
            <input matInput [(ngModel)]="this.Company.COCRegisterNr" (ngModelChange)="TestCompanyValidity();" [disabled]="!ShowStepOne">
          </mat-form-field>

          <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
            <mat-label>{{ 'Partners.Alias' | translate }}</mat-label>
            <input matInput [(ngModel)]="this.Company.Alias" (ngModelChange)="TestCompanyValidity();" [disabled]="!ShowStepOne">
          </mat-form-field>

            <button *ngIf="ShowStepOne" mat-flat-button color="primary" class="NewCompanyButton" [disabled]="UnValidCompany" (click)="GetCompany();">
            <i class="material-icons">forward</i>
              {{'Continue' | translate}}
            </button>

            <button *ngIf="ShowStepTwo" mat-button color="primary" class="NewCompanyButton" [disabled]="UnValidCompany" (click)="BackToStepOne();">
              <i class="material-icons">arrow_back_ios</i>
                {{'Back' | translate}}
              </button>

            <div *ngIf="ShowStepTwo">

              <div class="MainTitleBarNewCompany">
                {{ 'DefaultAddress' | translate }}
              </div>

              <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
                <mat-label>{{ 'Partners.PartnerWindow.StateProvince' | translate }}</mat-label>
                <input matInput [(ngModel)]="Address.StateProvince" (ngModelChange)="TestCompanyAddressValidity();">
              </mat-form-field>

              <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
                <mat-label>{{ 'Partners.PartnerWindow.City' | translate }}</mat-label>
                <input matInput [(ngModel)]="Address.City" (ngModelChange)="TestCompanyAddressValidity();">
              </mat-form-field>

              <mat-form-field class="example-full-width NewCompanyTextField" appearance="outline">
                <mat-label>{{ 'Partners.PartnerWindow.AddressLine' | translate }}</mat-label>
                <input matInput [(ngModel)]="Address.AddressLine" (ngModelChange)="TestCompanyAddressValidity();">
              </mat-form-field>

              <button *ngIf="ShowStepTwo" mat-raised-button color="accent" class="AddCompanyButton" [disabled]="UnValidAddress" (click)="AddCompany();">
                <i class="material-icons">check</i>
                  {{'NewCompanyButton' | translate}}
              </button>

            </div>
      </div>
      </div>
</div>
